import { Grid } from '@mui/material';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import WorkQueues from 'enums/workQueue.enum';
import { getProfileIncompletePatientsByPage } from 'store/thunks/workQueueThunks';
import { useWorkQueueTabSwitch } from '../contexts/WorkQueueTabSwitchContext';

import IncompleteProfilesFilterStatusBar from './IncompleteProfilesFilterStatusBar';
import IncompleteProfilesFilterButton from './IncompleteProfilesFilterButton';
import IncompleteProfilesTable from './IncompleteProfilesTable';

const IncompleteProfiles = () => {
  const dispatch = useDispatch();
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const { currentPage } = useSelector(({ workQueue }) => workQueue.profileIncomplete, shallowEqual);
  const { isTabSwitch } = useWorkQueueTabSwitch();

  useEffect(() => {
    if (isTabSwitch(WorkQueues.INCOMPLETE_PROFILES)) {
      dispatch(getProfileIncompletePatientsByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, isTabSwitch]);

  if (preset !== WorkQueues.INCOMPLETE_PROFILES) return null;

  return (
    <Grid container sx={{ py: 2 }}>
      <Grid item sx={{ minHeight: 40, flexGrow: 1 }} alignItems='center'>
        <IncompleteProfilesFilterStatusBar />
      </Grid>
      <Grid item>
        <IncompleteProfilesFilterButton />
      </Grid>
      <IncompleteProfilesTable />
    </Grid>
  );
};

export default IncompleteProfiles;
